import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {EformAPI} from '../../../e-form.api';
import {EformService} from "../../../service/eform.service";
import {MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteTrigger as MatAutocompleteTrigger} from '@angular/material/legacy-autocomplete';

export enum GroupName {
   Title = 'title',
   Name = 'name',
   Middle = 'middle',
   Surname = 'surname',
   Initial = 'initial'
}

@Component({
   selector: 'app-name',
   templateUrl: './name.component.html',
   styleUrls: ['./name.component.css']
})
export class NameComponent implements OnInit, AfterViewInit {
   @ViewChild('auto') autocomplete: MatAutocomplete;
   @ViewChild(MatAutocompleteTrigger) trigger: MatAutocompleteTrigger;
   @ViewChild('title') title: ElementRef;
   @Input() field: any = {};
   @Input() form: FormGroup;
   @Input() checkValidate: any;
   @Input() classes: any;
   @Input() fieldName: any;
   @Input() labelName: any;
   @Input() isFormName: any;
   private timer: any;
   placeholder: string;
   lang: string;
   label = {
      initial: '',
      middle: '',
      name: '',
      surname: '',
      title: ''
   };
   searchResult = [];
   includeTitle = false;
   isSelectedOption = false;
   checkInitial = false;
   value: any;
   initialValue: string = '';
   middleValue: string = '';
   nameValue: string = '';
   surnameValue: string = '';
   titleOtherValue: string = '';
   titleValue: string = '';
   type: number;
   previousValue: string;
   isInvalidValue: boolean = false;
   isInitialValue: boolean = false;
   isInvalidTitleValue: boolean = false;

   constructor(private translate: TranslateService, private api: EformAPI, private eformService: EformService, private ref: ChangeDetectorRef) {
   }

   ngOnInit(): void {
      this.initialValue = this.eformService.eForm.value.value && this.eformService.eForm.value.value['initial' + this.fieldName] ? this.eformService.eForm.value.value['initial' + this.fieldName] : this.initialValue;
      this.middleValue = this.eformService.eForm.value.value && this.eformService.eForm.value.value['middle' + this.fieldName] ? this.eformService.eForm.value.value['middle' + this.fieldName] : this.middleValue;
      this.nameValue = this.eformService.eForm.value.value && this.eformService.eForm.value.value['name' + this.fieldName] ? this.eformService.eForm.value.value['name' + this.fieldName] : this.nameValue;
      this.surnameValue = this.eformService.eForm.value.value && this.eformService.eForm.value.value['surname' + this.fieldName] ? this.eformService.eForm.value.value['surname' + this.fieldName] : this.surnameValue;
      this.titleOtherValue = this.eformService.eForm.value.value && this.eformService.eForm.value.value['titleOther' + this.fieldName] ? this.eformService.eForm.value.value['titleOther' + this.fieldName] : this.titleOtherValue;
      this.titleValue = this.eformService.eForm.value.value && this.eformService.eForm.value.value['title' + this.fieldName] ? this.eformService.eForm.value.value['title' + this.fieldName] : this.titleValue;

      this.lang = this.eformService.selectedLanguage;
      this.setLabel();
   }

   ngAfterViewInit() {
      if (this.titleValue && this.titleValue !== '') {
         if (this.titleValue.toString() === 'อื่นๆ' || this.titleValue.toString().toLowerCase() === 'other') {
            this.includeTitle = true;
            this.setRequiredTitleOther();
         } else {
            this.includeTitle = false;
            this.clearRequiredTitleOther();
            this.form.controls['titleOther' + this.fieldName].setErrors(null);
         }
         this.isSelectedOption = true;
      }
      // check if open from save draft
      if (this.initialValue && this.initialValue !== '' && this.initialValue.length !== 2) {
         this.form.get('initial' + this.fieldName).setErrors({'incorrect': true});
         this.isInitialValue = true;
      }
      this.ref.detectChanges();
   }

   onBlur() {
      this.isInvalidTitleValue = false;
   }

   onFocusTitle(input,type) {
      this.type = type;
      if (this.previousValue && input.value) {
         return;
      }
      if (type === 2) {
         this.searchResult = [];
         let titleName = '';
         for (let i = 0; i < this.field.title.customizeData.length; i++) {
            switch (this.lang) {
               case 'th': {
                  titleName = this.field.title.customizeData[i].th;
                  break;
               }
               case 'cn': {
                  titleName = this.field.title.customizeData[i].cn;
                  break;
               }
               default: {
                  titleName = this.field.title.customizeData[i].en;
               }
            }
            this.searchResult.push({title: titleName});
         }
         if (this.searchResult.length > 0) {
            this.trigger.openPanel();
         }
      } else {
         this.api.getTitleName('', this.lang, type.toString())
            .subscribe(data => {
               this.searchResult = data;
               if (this.searchResult.length > 0) {
                  this.trigger.openPanel();
               }
               this.ref.detectChanges();
            });
      }
   }

   selectKeyPress(input, type, open: boolean = true) {
      this.type = type;
      if (input.value.toString() === 'อื่นๆ' || input.value.toString().toLowerCase() === 'other') {
         this.includeTitle = true;
         this.isSelectedOption = true;
         this.setRequiredTitleOther();
      } else {
         this.includeTitle = false;
         this.isSelectedOption = false;
         this.clearRequiredTitleOther();
         this.form.controls['titleOther' + this.fieldName].setValue('');
      }
      this.setSearchResult(input.value, open);
   }

   changeOption(value) {
      this.previousValue = value.toString();
      if (value.toString().indexOf('อื่นๆ') > -1 || value.toString().indexOf('Other') > -1) {
         this.includeTitle = true;
         this.setRequiredTitleOther();
      } else {
         this.includeTitle = false;
         this.clearRequiredTitleOther();
         this.form.controls['titleOther' + this.fieldName].setErrors(null);
      };
      this.setSearchResult(value);
      this.isSelectedOption = true;
      this.checkInvalidValue();
   }

   setLabel() {
      this.label.initial = this.setLabelName(this.field.nameLabel.labelInitial);
      this.label.middle = this.setLabelName(this.field.nameLabel.labelMiddle);
      this.label.name = this.setLabelName(this.field.nameLabel.labelName);
      this.label.surname = this.setLabelName(this.field.nameLabel.labelSurname);
      this.label.title = this.setLabelName(this.field.nameLabel.labelTitle);
   }

   setLabelName(label) {
      switch(this.lang) {
         case 'th' :{
            return label.th;
         }
         case 'cn': {
            return label.cn;
         }
         default: {
            return label.en;
         }
      }
   }

   helperTranslater(type: string, value: string) {
      let _text = '';
      this.translate.get(`eform.field-properties.${type}.${value}`).subscribe(s => {
         _text = s;
      });
      return _text;
   }

   onCheckInitial(input) {
      if (input.value.length === 1) {
         this.checkInitial = true;
         this.form.controls['initial' + this.fieldName].setErrors({'incorrect': true});
      } else {
         this.checkInitial = false;
         if (this.form.controls['initial' + this.fieldName].hasValidator(Validators.required) && input.value.length !== 2) {
            this.form.controls['initial' + this.fieldName].setErrors({'incorrect': true});
         } else {
            this.form.controls['initial' + this.fieldName].setErrors(null);
         }
      }
   }

   checkTitleName(): void {
      this.searchResult = [];
      this.api.getTitleName('', this.lang, "1")
         .subscribe(data => {
            this.searchResult = data;
            if (this.searchResult.length > 0) {
               let found = this.searchResult.findIndex(o => o['title'] === this.titleValue) !== -1;
               if (!found && (!this.titleValue && !this.titleOtherValue)) {
                  this.isInvalidTitleValue = true;
               }
            }
            this.ref.detectChanges();
         });
   }

   setSearchResult(value, open: boolean = false) {
      if (this.type === 2) {
         let titleName = '';
         this.searchResult = [];
         if ((this.searchResult.length === 0 && value) ) {
            for (let i = 0; i < this.field.title.customizeData.length; i++) {
               switch(this.lang) {
                  case 'th' :{
                     titleName = this.field.title.customizeData[i].th;
                     break;
                  }
                  case 'cn': {
                     titleName = this.field.title.customizeData[i].cn;
                     break;
                  }
                  default: {
                     titleName = this.field.title.customizeData[i].en;
                  }
               }

               if (titleName.toLowerCase().indexOf(value.toString().toLowerCase()) > -1 || this.field.title.customizeData[i].id === 9001) {
                  this.searchResult.push({title: titleName});
               }
            }
            if (!open) {
               this.trigger.closePanel();
               setTimeout(() => {
                  this.title.nativeElement.blur();
               }, 100);
            }
         }
      } else {
         if (this.timer) {
            clearTimeout(this.timer);
         }
         const q = encodeURIComponent(value.trim());

         if (q.length === 0) {
            this.searchResult = [];
            return;
         }
         this.timer = setTimeout(() => {
            this.timer = null;
            this.api.getTitleName(q, this.lang, this.type.toString())
               .subscribe(
                  data => {
                     if (this.timer == null) {
                        if (this.autocomplete.isOpen) {
                           this.trigger.closePanel();
                        }
                        this.searchResult = data;
                        if (this.searchResult.length > 0) {
                           if (open) {
                              this.trigger.openPanel();
                           } else {
                              this.title.nativeElement.blur();
                           }
                        }
                     }
                  });
         }, 300);
      }

   }

   autoCompTitle(input) {
      let value = input.value.toString();
      const matchedTitle = this.searchResult.find(x => x.title.toLowerCase() === value.toLowerCase());
      if (!this.previousValue) {
         if (value.toLowerCase() === 'other' || value.toLowerCase() === 'other.') {
            this.titleValue = 'Other'
            this.trigger.closePanel();
            this.selectKeyPress({value: this.titleValue}, this.type, false);
         } else {
            if (matchedTitle) {
               this.titleValue = matchedTitle.title;
               this.previousValue = this.titleValue;
               this.changeOption(this.titleValue);
               this.trigger.closePanel();
               this.ref.markForCheck();
               this.isSelectedOption = true;
            } else {
               this.isSelectedOption = false;
            }
         }
      } else {
         if (matchedTitle) {
            this.titleValue = matchedTitle.title;
            this.previousValue = this.titleValue;
            this.changeOption(this.titleValue);
            this.ref.markForCheck();
            this.isSelectedOption = true;
         } else {
            this.isSelectedOption = false;
         }
      }
      this.checkInvalidValue();
      this.ref.markForCheck();
   }

   setRequiredTitleOther(): void {
      let titleOther = this.form.controls['titleOther' + this.fieldName];
      titleOther.setValidators([Validators.required]);
      titleOther.updateValueAndValidity();
   }

   clearRequiredTitleOther(): void {
      let titleOther = this.form.controls['titleOther' + this.fieldName];
      titleOther.clearValidators();
      titleOther.updateValueAndValidity();
   }

   checkInvalidValue() {
      if ((this.form.get('title' + this.fieldName).value !== '' && (this.form.get('title' + this.fieldName).dirty && this.form.get('title' + this.fieldName).status === 'VALID')) && !this.checkValidate && !this.isSelectedOption) {
         this.form.controls['titleOther' + this.fieldName].setErrors({'incorrect': true});
         this.isInvalidValue = true;
      } else {
         this.form.controls['titleOther' + this.fieldName].setErrors(null);
         this.isInvalidValue = false;
      }
   }

   checkInitialValue() {
      if (this.checkInitial && this.form.get('initial' + this.fieldName).status === 'INVALID' && this.form.get('initial' + this.fieldName).value !== '') {
         this.isInitialValue = true;
      } else {
         this.isInitialValue = false;
      }
   }
}
